<template>
  <!-- name: '我要捐-三级页面容器' -->
  <div class="thirdWrap">
    <GoBack
      :title="title"
      :nextPath="$route.query.nextPath"
      :nextQuery="
        title === '捐赠详情'
          ? JSON.stringify({
              title: '我的捐赠',
              status: $route.query.status,
              curSelectTab: Number($route.query.donateType) === 1 ? '捐衣' : '捐物',
            })
          : ''
      "
    />
    <MyDonateDetail v-if="title === '捐赠详情'" />
    <ProjectDetail :name="$route.query.name" v-else />
  </div>
</template>

<script>
import GoBack from "@/components/GoBack";
import ProjectDetail from "./components/projectDetail.vue";
import MyDonateDetail from "./components/myDonateDetail.vue";
export default {
  components: { GoBack, ProjectDetail, MyDonateDetail },
  data() {
    return {
      title: "项目详情",
      curStatus: 1,
    };
  },
  created() {
    this.title = this.$route.query.title;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.thirdWrap {
  height: calc(100% - 100px);
  width: 100%;
  overflow: hidden;
  margin-bottom: 37px;
}
</style>
